/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var mixin = require('../mixin');
var olExt = require('../ol-ext');
var assert = require('../util/assert');
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var minilo = require('../util/minilo');

var GroupLayer = __ol__.layer.Group;
var methods = {
  createLayer: function createLayer() {
    return new GroupLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      extent: this.extent,
      zIndex: this.zIndex
    });
  },
  getLayersTarget: function getLayersTarget() {
    assert.hasLayer(this);

    if (this._layersTarget == null) {
      this._layersTarget = new olExt.IndexedCollectionAdapter(this.$layer.getLayers(), function (layer) {
        return layer.get('id');
      });
    }

    return this._layersTarget;
  },
  getServices: function getServices() {
    return mergeDescriptors(mixin.layer.methods.getServices.call(this), mixin.layersContainer.methods.getServices.call(this));
  }
};

var Layer = {
  name: 'vl-layer-group',
  mixins: [mixin.layer, mixin.layersContainer],
  methods: methods
};

var index = {
  Layer: Layer,
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Layer, options);

    Vue.component(Layer.name, Layer);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/group-layer/index.js
// module id = 1462
// module chunks = 1